var _rect, _rect2, _path, _path2, _path3, _path4, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRs(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.21164,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "#F5F5F5",
    strokeWidth: 0.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_2546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 16
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.21164,
    y: 0.25,
    width: 21.5,
    height: 15.5,
    rx: 1.75,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_2546)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.961639 10.6667H22.9616V5.33333H0.961639V10.6667Z",
    fill: "#17508F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.961639 5.33333H22.9616V0H0.961639V5.33333Z",
    fill: "#E1444D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67593 8C5.67593 7.51134 5.91806 6.45449 6.07308 5.82794C6.1455 5.53525 6.40931 5.33333 6.71082 5.33333H8.8327C9.13366 5.33333 9.39712 5.5345 9.46981 5.82655C9.62485 6.4495 9.86641 7.50027 9.86641 8C9.86641 8.58498 9.48769 10.1032 9.3743 10.5446C9.35345 10.6258 9.31728 10.7014 9.26405 10.7662C9.04627 11.031 8.40872 11.7333 7.77117 11.7333C7.13319 11.7333 6.49521 11.0301 6.27785 10.7656C6.22494 10.7012 6.18887 10.6261 6.16799 10.5454C6.05453 10.1071 5.67593 8.59946 5.67593 8Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1_2546",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 5,
    height: 7
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.67593 8C5.67593 7.51134 5.91806 6.45449 6.07308 5.82794C6.1455 5.53525 6.40931 5.33333 6.71082 5.33333H8.8327C9.13366 5.33333 9.39712 5.5345 9.46981 5.82655C9.62485 6.4495 9.86641 7.50027 9.86641 8C9.86641 8.58498 9.48769 10.1032 9.3743 10.5446C9.35345 10.6258 9.31728 10.7014 9.26405 10.7662C9.04627 11.031 8.40872 11.7333 7.77117 11.7333C7.13319 11.7333 6.49521 11.0301 6.27785 10.7656C6.22494 10.7012 6.18887 10.6261 6.16799 10.5454C6.05453 10.1071 5.67593 8.59946 5.67593 8Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1_2546)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.86642 5.86667L5.67594 11.2",
    stroke: "#E1444D",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.67594 5.86667L9.86642 11.2",
    stroke: "#E1444D",
    strokeWidth: 1.33333,
    strokeLinecap: "square"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRs);
export default __webpack_public_path__ + "static/media/rs.7bf87458fa8385b657ce45cb8b1e6c22.svg";
export { ForwardRef as ReactComponent };